import i18n from '@/plugins/i18n';
import appVersion from '@/app-version';

interface ReleaseNote {
  version: string;
  date: Date;
  features?: { title: string; description?: string }[];
  improvements?: { title: string; description?: string }[];
}

export const releaseNotes = [
  {
    version: '1.18.0',
    date: new Date('2026-08-17'),
    features: [
      {
        title: i18n.t('whats_new.1_18_0.feature_1'),
        description: i18n.t('whats_new.1_18_0.feature_1_description'),
      },
    ],
  },
  {
    version: '1.17.16',
    date: new Date('2026-07-02'),
    features: [
      {
        title: i18n.t('whats_new.1_17_16.feature_1'),
        description: i18n.t('whats_new.1_17_16.feature_1_description'),
      },
      {
        title: i18n.t('whats_new.1_17_16.feature_2'),
        description: i18n.t('whats_new.1_17_16.feature_2_description'),
      },
    ],
  },
  {
    version: '1.17.12',
    date: new Date('2026-05-22'),
    features: [
      {
        title: i18n.t('whats_new.1_17_12.feature_1'),
        description: i18n.t('whats_new.1_17_12.feature_1_description'),
      },
    ],
  },
  {
    version: '1.17.10',
    date: new Date('2026-05-14'),
    features: [{ title: i18n.t('whats_new.1_17_10.feature_1') }],
  },
  {
    version: '1.17.1',
    date: new Date('2026-03-12'),
    features: [
      { title: i18n.t('whats_new.1_17_0.feature_1') },
      { title: i18n.t('whats_new.1_17_0.feature_3') },
      {
        title: i18n.t('whats_new.1_17_0.feature_2'),
        description: i18n.t('whats_new.1_17_0.feature_2_description'),
      },
    ],
  },
  {
    version: '1.17.4',
    date: new Date('2026-04-03'),
    features: [
      { title: i18n.t('whats_new.1_17_4.feature_1') },
    ],
    improvements: [
      {
        title: i18n.t('whats_new.1_17_4.improvement_1'),
        description: i18n.t('whats_new.1_17_4.improvement_1_description'),
      },
      {
        title: i18n.t('whats_new.1_17_4.improvement_2'),
        description: i18n.t('whats_new.1_17_4.improvement_2_description'),
      },
    ],
  },
  {
    version: '1.17.5',
    date: new Date('2026-04-06'),
    improvements: [
      {
        title: i18n.t('whats_new.1_17_5.improvement_1'),
        description: i18n.t('whats_new.1_17_5.improvement_1_description'),
      },
    ],
  },
  {
    version: '1.17.6',
    date: new Date('2026-04-21'),
    features: [
      { title: i18n.t('whats_new.1_17_6.feature_1'), description: i18n.t('whats_new.1_17_6.feature_1_description') },
      { title: i18n.t('whats_new.1_17_6.feature_2') },
      { title: i18n.t('whats_new.1_17_6.feature_3') },
    ],
  },
  {
    version: '1.17.7',
    date: new Date('2026-04-28'),
    features: [
      {
        title: i18n.t('whats_new.1_17_7.feature_1'),
        description: i18n.t('whats_new.1_17_7.feature_1_description'),
      },
      { title: i18n.t('whats_new.1_17_7.feature_2') },
    ],
  },
].sort((a, b) => (a.date > b.date ? -1 : 1)) as ReleaseNote[];

export const hasReleaseNote = () => releaseNotes.some((note) => note.version === appVersion);
